import TimeSliderView from "./TimeSliderView";


/** Clase que controla el comportamiento visual del TimeSlider con precarga en la animación (Radar y Satélites) */
class PreloadedTimeSliderView extends TimeSliderView{


    /**
     * Elemento HTML de la barra de precarga y animación fluida
     *
     * @protected
     */
    protected readonly playbar: HTMLElement | null = null;

    /**
     * Crea e inicializa un objeto
     *
     * @param timeSliderElement
     */
    constructor( timeSliderElement:Element ) {
        let slider:Element|null = timeSliderElement;

        super(slider);


        if (slider) {
            this.playbar = slider.querySelector("#play-bar");
        }

        // Función que se ejecuta al hacer click sobre el botón Play
        this.buttonPlay?.addEventListener("click", () =>{
            if ( ! this.playing && this.redrawFinished )
                this.startPlaying(24);
        });

    }

    /**
     * Habilita la barra de precarga
     */
    enablePlayBar(){
        if(this.slider)
            this.slider.classList.add("playing");
    }

    /**
     * Deshabilita la barra de precarga
     */
    disablePlayBar(){
        if(this.slider)
            this.slider.classList.remove("playing");
    }


    /**
     * Escribe en la barra de precarga el porcentaje de carga y pinta con un color más oscuro ese porcentaje del area de la barra
     *
     * @param progress Valor númerico que representa un porcentaje
     */
    setProgressPercent(progress: number){
        if (this.playbar) {
            const text = this.playbar.querySelector("#center_text");
            //this.playbar.style.background = "linear-gradient(90deg, #004562 " + progress + "%, #005a81 0%)";
            this.playbar.style.background = "linear-gradient(90deg, rgba(0, 60, 89, 0.36) " + progress + "% , rgba(0, 60, 89, 0.2) 0%)";
            if(text)
                text.innerHTML = progress + " %";
        }
    }

    /**
     * Escribe en la barra de precarga un texto que normalmente será en formato HH:MM
     *
     * @param text Cadena de texto a escribi
     */
    setProgressText(text: string){
        if (this.playbar) {
            const textspan = this.playbar.querySelector("#center_text");
            if(textspan)
                textspan.innerHTML = text;

        }
    }
}

export default PreloadedTimeSliderView;
